import { useState } from "react";
import { formatExpiryDate } from "../../utils/formatters";
import styles from "./ScanModal.module.css";

// mode: "add" | "remove" | "workOrder" | "delivery"
export default function ScanModal({ product, mode = "add", onConfirm, onClose }) {
  const [qty, setQty] = useState(1);
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  const isRemoval = mode !== "add";

  const handleConfirm = () => {
    const q = parseInt(qty);
    if (isNaN(q) || q < 1) { setError("Quantity must be at least 1"); return; }
    if (isRemoval && q > product.stock) {
      setError(`Cannot remove ${q} — only ${product.stock} in stock.`); return;
    }
    onConfirm({ qty: q, notes });
  };

  const stockClass = product.stock > 10 ? styles.stockGood : product.stock > 0 ? styles.stockWarn : styles.stockDanger;

  const labels = {
    add: { title: "Add to Inventory", button: "CONFIRM ADD", btnClass: styles.confirmBtnIn },
    remove: { title: "Remove from Inventory", button: "CONFIRM REMOVE", btnClass: styles.confirmBtnOut },
    workOrder: { title: "Work Order Item", button: "CONFIRM USE", btnClass: styles.confirmBtnOut },
    delivery: { title: "Delivery Item", button: "CONFIRM USE", btnClass: styles.confirmBtnOut },
  };
  const label = labels[mode] || labels.add;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.title}>{label.title}</div>
          <button onClick={onClose} className={styles.closeBtn}>x</button>
        </div>
        <div className={styles.productInfo}>
          <div className={styles.productId}>{product.barcode || product.id}</div>
          <div className={styles.productDesc}>{product.description}</div>
          <div className={styles.productMfg}>{product.manufacturer}</div>
          {product.lotNumber && <div className={styles.productLot}>LOT: {product.lotNumber}</div>}
          {product.expiryDate && <div className={styles.productLot}>EXP: {formatExpiryDate(product.expiryDate)}</div>}
          <div className={styles.stockRow}>
            <span className={styles.stockLabel}>Current Stock:</span>
            <span className={stockClass}>{product.stock}</span>
          </div>
        </div>
        <div className={styles.fieldGroup}>
          <div className={styles.label}>Quantity</div>
          <input type="number" min="1" value={qty} onChange={e => { setQty(e.target.value); setError(""); }}
            className={styles.qtyInput} autoFocus />
        </div>
        <div className={styles.fieldGroupLast}>
          <div className={styles.label}>Notes (optional)</div>
          <input type="text" value={notes} onChange={e => setNotes(e.target.value)} placeholder="e.g. McKesson order #12345"
            className={styles.notesInput} />
        </div>
        {error && <div className={styles.error}>! {error}</div>}
        <button onClick={handleConfirm} className={label.btnClass}>
          {label.button} {qty}
        </button>
      </div>
    </div>
  );
}
